import './LoadingIndicatorLinear.css';
export function LoadingIndicatorLinear() {
    return (
        <div className="indicator position-relative w-100">
            <div></div>
        </div>
    );
}
